import React, { useState, useEffect, useContext } from "react"
import { Helmet } from 'react-helmet';
import {
  Box,
  Container,
  Typography
} from '@material-ui/core';

import LanguageContext from "../contexts/LanguageContext"

const NotFound = () => {

  const { actLanguage, languageValues } = useContext(LanguageContext)

  return (
    <>
      <Helmet>
        <title>404 | TheLab</title>
      </Helmet>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          justifyContent: 'center'
        }}
      >
        <Container maxWidth="md">
          <Typography
            align="center"
            color="text.black"
            variant="h1"
          >
            {languageValues?.page404[actLanguage] || ''}
          </Typography>
        </Container>
      </Box>
    </>
  )
};

export default NotFound;
